/**
 * @generated SignedSource<<c417d7bba952c3ed78af209471fcd903>>
 * @relayHash d81de99d75912b13f652b0a7bf91bfd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9e1ca350c979db933088f1e74827069aaf527308e30d6ec8b18fda46d1adb92

import type { ConcreteRequest, Query } from 'relay-runtime';
export type view_issueColoredLabelsQuery$variables = {
  issueAris: ReadonlyArray<string>;
};
export type view_issueColoredLabelsQuery$data = {
  readonly jira_issuesByIds: ReadonlyArray<{
    readonly fields: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldId?: string;
          readonly selectedLabelsConnection?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly color: {
                  readonly colorKey: string | null | undefined;
                } | null | undefined;
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined> | null | undefined;
};
export type view_issueColoredLabelsQuery = {
  response: view_issueColoredLabelsQuery$data;
  variables: view_issueColoredLabelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAris"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "issueAris"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "colorKey"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "view_issueColoredLabelsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "selectedLabelsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraLabelEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraLabelsField"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "view_issueColoredLabelsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "concreteType": "JiraLabelConnection",
                            "kind": "LinkedField",
                            "name": "selectedLabelsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraLabelEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraLabel",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v2/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraLabelsField"
                      },
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c9e1ca350c979db933088f1e74827069aaf527308e30d6ec8b18fda46d1adb92",
    "metadata": {},
    "name": "view_issueColoredLabelsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a1190e22498f826964af5cb163bda524";

export default node;
